import { motion } from 'framer-motion';
import styled from 'styled-components';

import { colors } from 'utils/styles/theme';

const DropdownArrow = 'svgs/dropdown.svg';

interface ToggleProps {
  isOpen: boolean;
}

export const Wrapper = styled.section``;

export const PanelWrapper = styled(motion.li)`
  border-top: 1px solid ${colors.white};
`;

export const List = styled.ul`
  ${PanelWrapper} {
    &:last-child {
      border-bottom: 1px solid ${colors.white};
    }
  }
`;

export const Content = styled(motion.div)`
  overflow: hidden;
`;

export const InnerContent = styled.div`
  padding: 10px 0 24px;
`;

export const Toggle = styled.a<ToggleProps>`
  position: relative;
  display: block;

  padding: 20px 0;

  cursor: pointer;

  &:after {
    content: '';
    width: 25px;
    height: 16px;

    position: absolute;
    top: calc(50% - 8px);
    right: 15px;

    background: url(${DropdownArrow}) transparent no-repeat no-repeat;
    transition: transform 0.4s ease;
    transform: scale(0.75)
      rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
  }
`;
